module.exports = __webpack_public_path__ + "img/flexsale-refined-4.e727ec2b.png";